import { createContext, useContext } from 'react'

interface UserContextInterface {
  id: string
  username: string
  fullName?: string | null
  email: string
  createdAt: string
  updatedAt: string
  business?: {
    id: string
    name: string
    wasteReductionPerCycle: number
    co2ReductionPerKiloWaste: number
  } | null
}

export const UserContext = createContext<UserContextInterface | null>(null)

export function useUser() {
  return useContext(UserContext)
}
